export const SET_SFTP_CONNECTION_SELECTED = 'SET_SFTP_CONNECTION_SELECTED';
export const DELETE_SFTP_CONNECTION = 'DELETE_SFTP_CONNECTION';
export const SET_IS_LOADING_DELETE_SFPT_CONNECTIONS = 'SET_IS_LOADING_DELETE_SFPT_CONNECTIONS';
export const ADD_NEW_CONNECTION = 'ADD_NEW_CONNECTION';
export const SET_IS_LOADING_CREATE_SFPT_CONNECTIONS = 'SET_IS_LOADING_CREATE_SFPT_CONNECTIONS';
export const UPDATE_CONNECTION = 'UPDATE_CONNECTION';
export const SET_IS_LOADING_UPDATE_SFPT_CONNECTIONS = 'SET_IS_LOADING_UPDATE_SFPT_CONNECTIONS';
